import { render, staticRenderFns } from "./entryWorks.vue?vue&type=template&id=d0226016&scoped=true&"
import script from "./entryWorks.vue?vue&type=script&lang=js&"
export * from "./entryWorks.vue?vue&type=script&lang=js&"
import style0 from "./entryWorks.vue?vue&type=style&index=0&id=d0226016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0226016",
  null
  
)

export default component.exports